module.exports = __webpack_public_path__ + "img/5金卡阳台套房.bf1c0b2.jpg";